import EventModel from '@/common/models/rules/event-model';
import EventTypes from '@/common/api/definitions/event-types';

const event = new EventModel({eventType: EventTypes.gatewayAccountRequested});

export default event;
